

import React, { memo } from 'react';

import CollaboratorsList from './CollaboratorsList';








function AddUsersTab(props) {
  const { users, onAddMember, membersIds, loading } = props;

  return (
    <CollaboratorsList
      listItems={users}
      type="users"
      onAddMember={onAddMember}
      membersIds={membersIds}
      loading={loading} />);


}

export default memo(AddUsersTab);